import classNames from "classnames";
import React from "react";
import { BlockPicker } from "react-color";

import { useAppSelector } from "../../../../../redux/hooks";
import { FrameStencil } from "../../../../../types";
import { usePlayContext } from "../../../play-context";
import toolPaneStyles from "../tool-pane.module.scss";
import styles from "./stencil-tools.module.scss";

const DEFAULT_COLORS = [
  "#2D72D2",
  "#238551",
  "#C87619",
  "#CD4246",
  "#9D3F9D",
  "#000000",
  "#5F6B7C",
  "#D3D8DE",
  "#FFFFFF",
];

export interface StencilToolsProps {
  stencil: FrameStencil;
}

export const StencilTools = ({ stencil }: StencilToolsProps) => {
  const theme = useAppSelector((state) => state.theme);
  const { teamColor } = theme;

  const { frameStencilsApi } = usePlayContext();
  const { updateStencilColor } = frameStencilsApi;

  const { color } = stencil;

  return (
    <div className={classNames(toolPaneStyles.tools, styles.colorPicker)} onClick={(e) => e.stopPropagation()}>
      <BlockPicker
        color={color}
        onChange={(color) => updateStencilColor({ id: stencil.id, color: color.hex, skipSave: true })}
        onChangeComplete={(color) => updateStencilColor({ id: stencil.id, color: color.hex, skipSave: false })}
        triangle="hide"
        colors={[
          ...DEFAULT_COLORS,
          ...(!DEFAULT_COLORS.map((color) => color.split("#")[1]).includes(teamColor) ? [`#${teamColor}`] : []),
        ]}
      />
    </div>
  );
};
